// Retourne l'URL publique canonique de l'application (utilisée pour
// générer les QR codes et liens partagés qui doivent TOUJOURS pointer
// vers le domaine de production, même si l'enseignant les affiche
// depuis la preview.
//
// Ordre de priorité :
//   1. REACT_APP_PUBLIC_URL si définie en build (recommandé en prod)
//   2. Sinon, on utilise le hostname courant SI c'est déjà codevoiture.fr
//   3. Sinon, on hardcode https://codevoiture.fr (fallback production)
//
// Pour le dev local, on peut passer REACT_APP_PUBLIC_URL=http://localhost:3000

const HARDCODED_PROD_URL = 'https://codevoiture.fr';

export function getPublicOrigin() {
  const envUrl = (process.env.REACT_APP_PUBLIC_URL || '').trim();
  if (envUrl) return envUrl.replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;
    // Utilise l'origin courant seulement si on est déjà sur le domaine canonique
    if (hostname === 'codevoiture.fr' || hostname === 'www.codevoiture.fr' || hostname === 'localhost') {
      return origin;
    }
  }
  return HARDCODED_PROD_URL;
}
